import React, {useEffect} from "react";
import GuideLife_01 from './GuideLife_01';
import GuideLife_02 from './GuideLife_02';
import './GuideLife.scss';

const GuideLife = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  

  return (
    <>
      <section className="sec-guide-hero">
        <div className="GuideHero">
          <div className="box-main">
            <h1 className="guide-title">GISTian 생활</h1>
            <p className="guide-desc">지온나래·꾼·GIST 콘텐츠와 함께 캠퍼스 생활 정보를 한눈에 만나보세요.</p>
          </div>
        </div>
      </section>

      <section className="sec-guide-content">
        <div className="GuideContent">
          <div className="box-main">
            {/* <h2 className="content-title">생활 안내</h2> */}

            <div className="box-sections">
              <article className="art-section">
                <GuideLife_01 />
              </article>

              <article className="art-section">
                <GuideLife_02 />
              </article>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GuideLife;